/* istanbul ignore file */
import { FieldIdentifier, LogicBuilder } from '../../../models';
import { BasicDropdownValue } from '../../../models/basic-dropdown-value';
import { CheckBoxTriggerOperatorGridText, DateSelectTriggerOperatorGridText, DefaultTriggerOperatorGridText, DropdownTriggerOperatorGridText, NumberTriggerOperatorGridText, PersonTriggerOperatorGridText, TriggerOperator, UploaderTriggerOperatorGridText } from '../../../shared/enums';

export class LogicBuilderLogicServiceModel {
    isMapPinUsed = false;
    currentProjectLogicBuilders: LogicBuilder[] = [];
    styleFields: FieldIdentifier[] = [];
    setFields: FieldIdentifier[] = [];
    triggerFields: FieldIdentifier[] = [];
    smartsheetPullFields: FieldIdentifier[] = [];
    dateSelectTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: DateSelectTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.DateFieldIsInTheLastXDays, name: DateSelectTriggerOperatorGridText.DateFieldIsInTheLastXDays },
        { id: TriggerOperator.DateFieldIsInTheNextXDays, name: DateSelectTriggerOperatorGridText.DateFieldIsInTheNextXDays },
        { id: TriggerOperator.DateFieldIsInPast, name: DateSelectTriggerOperatorGridText.DateFieldIsInPast },
        { id: TriggerOperator.DateFieldIsInFuture, name: DateSelectTriggerOperatorGridText.DateFieldIsInFuture },
        { id: TriggerOperator.HasValue, name: DateSelectTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: DateSelectTriggerOperatorGridText.NoValue },
        { id: TriggerOperator.LessThan, name: DateSelectTriggerOperatorGridText.LessThan },
        { id: TriggerOperator.GreaterThan, name: DateSelectTriggerOperatorGridText.GreaterThan },
        { id: TriggerOperator.Equal, name: DateSelectTriggerOperatorGridText.EqualTo },
        { id: TriggerOperator.GreaterThanOrEqualTo, name: DateSelectTriggerOperatorGridText.GreaterThanOrEqualTo },
        { id: TriggerOperator.LessThanOrEqualTo, name: DateSelectTriggerOperatorGridText.LessThanOrEqualTo },

    ];
    checkBoxTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasValue, name: CheckBoxTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: CheckBoxTriggerOperatorGridText.NoValue },
        { id: TriggerOperator.HasChanged, name: CheckBoxTriggerOperatorGridText.HasChanged },
    ];
    dropdownTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: DropdownTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.Equal, name: DropdownTriggerOperatorGridText.Equal },
        { id: TriggerOperator.NotEqual, name: DropdownTriggerOperatorGridText.NotEqual },
        { id: TriggerOperator.HasValue, name: DropdownTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: DropdownTriggerOperatorGridText.NoValue },
    ];
    personTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: PersonTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.Equal, name: PersonTriggerOperatorGridText.Equal },
        { id: TriggerOperator.HasValue, name: PersonTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: PersonTriggerOperatorGridText.NoValue },
    ];
    uploaderTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: UploaderTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.HasValue, name: UploaderTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: UploaderTriggerOperatorGridText.NoValue },
    ];
    numberTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: NumberTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.HasValue, name: NumberTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: NumberTriggerOperatorGridText.NoValue },
        { id: TriggerOperator.GreaterThan, name: NumberTriggerOperatorGridText.GreaterThan },
        { id: TriggerOperator.LessThan, name: NumberTriggerOperatorGridText.LessThan },
        { id: TriggerOperator.Equal, name: NumberTriggerOperatorGridText.EqualTo },
        { id: TriggerOperator.GreaterThanOrEqualTo, name: NumberTriggerOperatorGridText.GreaterThanOrEqualTo },
        { id: TriggerOperator.LessThanOrEqualTo, name: NumberTriggerOperatorGridText.LessThanOrEqualTo },
    ];
    defaultTriggerOperators: BasicDropdownValue[] = [
        { id: TriggerOperator.HasChanged, name: DefaultTriggerOperatorGridText.HasChanged },
        { id: TriggerOperator.HasValue, name: DefaultTriggerOperatorGridText.HasValue },
        { id: TriggerOperator.NoValue, name: DefaultTriggerOperatorGridText.NoValue },
    ];
}
